import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { AddEditBranchComponent } from './addEditBranch.component';

import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import { BranchModel } from '../../../model/index';
import { BranchService } from '../../../services/index';

@Component({
    selector: 'branch-tab',
    templateUrl: './branch.component.html',
})
export class BranchMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public user_type: string;
    public list: any[] = [];
    public branchdata: any[] = [];

    isLoadMask: Promise<any>;
    branchData: BranchModel[];
    isLoading: boolean = false;
    userType:string;
    filterData = {
        "search_data": ""
    };

    constructor(public store: Store<fromRootStore.State>, private branchService: BranchService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'company_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('branchEmailTemplate') branchEmailTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('hvbranchTemp') hvBranchTemp: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Name', prop: 'company_name', width: 170, minWidth: 170, maxWidth: 170 },
            { name: 'Address', prop: 'address', width: 340, minWidth: 340, maxWidth: 340 },
            { name: 'Branch Email', prop: 'branch_email', width: 200, minWidth: 200, maxWidth: 200, cellTemplate: this.branchEmailTemplate },
            { name: 'IP Address', prop: 'branch_ip_address', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'HV Branch', prop: 'hv_status', width: 120, minWidth: 120, maxWidth: 120 , sortable: false, cellClass: 'cell-center', cellTemplate: this.hvBranchTemp},
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getBranchList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    clearFilter(): void {
        this.filterData = { "search_data": "" };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getBranchList();
    }

    getBranchList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.branchService
            .getBranchList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.branchData = res.data;
                that.userType = res.userType;
            });
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getBranchList();
    }

    bsModalRef: BsModalRef;
    public onAddEditBranch(mode: string, row: any,userType: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditBranchComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        if(mode == "Edit") {
            if(row['is_hv_center'] == 'false') {
                row['is_hv_center'] = false;
            } else {
                row['is_hv_center'] = true;
            }            
        }
        this.bsModalRef.content.title = mode + ' Branch Details';
        this.bsModalRef.content.userType = userType;
        this.bsModalRef.content.branchdata = Object.assign({}, row);
        this.bsModalRef.content.branchLoadEvent.subscribe(($e) => {
            that.getBranchList();
            this.store.dispatch(new commonActions.LoadAllBranch());
        });
    }

    onDeleteBranch(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Branch: ' + row.company_name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.branchService
                .deleteBranch(row.company_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getBranchList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/branch/branch.component.ts